import { useState } from "react";
import { toast } from "sonner";
import { Loader2, X } from "lucide-react";
import { api, formatApiErrorDetail } from "../../api";
import { DateInput, todayISO } from "../../DateInput";
import { Field } from "./shared";

const ModalHeader = ({ title, onClose }) => (
  <div className="flex items-center justify-between px-5 py-4 border-b border-slate-200">
    <div>
      <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500">Fechar relatório</div>
      <h3 className="mt-0.5 font-serif-display text-xl">{title}</h3>
    </div>
    <button onClick={onClose} data-testid="admin-mark-paid-close" className="p-1.5 hover:bg-slate-100 rounded-sm text-slate-500">
      <X size={18} />
    </button>
  </div>
);

export function MarkPaidModal({ row, onClose, onSaved }) {
  const [file, setFile] = useState(null);
  const [paidAt, setPaidAt] = useState(todayISO());
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!file) {
      toast.error("Anexe o comprovante de pagamento.");
      return;
    }
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append("proof", file);
      if (paidAt) fd.append("paid_at", paidAt);
      if (notes) fd.append("notes", notes);
      await api.post(`/admin/despesas/${row.id}/pagar`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Relatório marcado como pago.");
      onSaved();
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-mark-paid-modal" className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white w-full max-w-lg rounded-sm shadow-xl" onClick={(e) => e.stopPropagation()}>
        <ModalHeader title={row.title} onClose={onClose} />
        <div className="p-5 space-y-4">
          <Field label="Data do pagamento">
            <DateInput value={paidAt} onChange={setPaidAt} testid="admin-mark-paid-date" />
          </Field>
          <Field label="Comprovante de pagamento (PDF/JPG/PNG)">
            <input type="file" accept=".pdf,.jpg,.jpeg,.png,.webp"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
              className="mt-1 w-full text-sm" data-testid="admin-mark-paid-file" />
          </Field>
          <Field label="Observações (opcional)">
            <textarea rows={3} value={notes} onChange={(e) => setNotes(e.target.value)}
              className="mt-1 w-full border border-slate-300 px-3 py-2 rounded-sm" data-testid="admin-mark-paid-notes" />
          </Field>
        </div>
        <div className="px-5 py-4 border-t border-slate-200 flex justify-end gap-2">
          <button onClick={onClose} data-testid="admin-mark-paid-cancel"
            className="px-4 py-2 border border-slate-300 text-[11px] uppercase tracking-[0.25em] hover:bg-slate-50">
            Cancelar
          </button>
          <button data-testid="admin-mark-paid-save" onClick={save} disabled={saving}
            className="inline-flex items-center gap-2 px-4 py-2 bg-[#002776] text-white text-[11px] uppercase tracking-[0.25em] hover:bg-[#001a5a] disabled:opacity-60">
            {saving && <Loader2 size={14} className="animate-spin" />}
            Confirmar pagamento
          </button>
        </div>
      </div>
    </div>
  );
}
